import Feedback from 'react-bootstrap/Feedback';
import React from 'react';
import styles from './FeedbackWrapper.scss';

const FeedbackWrapper = ({ children, ...rest }) => {
  return (
    <Feedback {...rest} className={styles['feedback-wrapper']} type="invalid">
      <div className={styles['feedback-icon']} />
      {children}
    </Feedback>
  );
};

export default FeedbackWrapper;
